"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const WorkItemPillSection_1 = require("../../WorkItemPillSection");
const LinkCard_1 = __importDefault(require("@Components/LinkCard"));
const ExtendedWorkFields_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem/ExtendedWorkFields"));
const ExtendedWorkWriterFields_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem/ExtendedWorkWriterFields"));
const clsx_1 = __importDefault(require("clsx"));
const Checkbox_1 = __importDefault(require("@Components/Selectors/Checkbox"));
const mobx_react_1 = require("mobx-react");
const ExtendedWorkItem = (props) => {
    var _a;
    const { work, catalogPath, fields, secondaryFields, showOverclaimStatus, bottomFields, isBulkActionStarted, isBulkActionDisabled, bulkActionToggle, isBulkActionSelected, } = props;
    const handleOnClick = (0, react_1.useCallback)(() => {
        if (work && props.handleOnClick) {
            props.handleOnClick(work);
        }
    }, []);
    return (react_1.default.createElement(LinkCard_1.default, { className: (0, clsx_1.default)('extended-work-item', isBulkActionDisabled && isBulkActionStarted && 'bulk-action-disabled'), path: catalogPath, handleOnClick: handleOnClick, disabled: isBulkActionStarted },
        react_1.default.createElement("div", { className: 'top' },
            react_1.default.createElement("div", { className: 'left-data' },
                react_1.default.createElement("div", { className: 'work-data' },
                    react_1.default.createElement("div", { className: (0, clsx_1.default)('work-title', isBulkActionStarted && 'bulk-action-editing') },
                        isBulkActionStarted && bulkActionToggle && isBulkActionSelected && (react_1.default.createElement(Checkbox_1.default, { key: work.overclaimHeaderId, id: ((_a = work.overclaimHeaderId) === null || _a === void 0 ? void 0 : _a.toString()) || '', onClick: () => {
                                bulkActionToggle(work.overclaimHeaderId);
                            }, checked: isBulkActionSelected(work.overclaimHeaderId), mainColor: true, disabled: isBulkActionDisabled })),
                        work.title),
                    react_1.default.createElement(ExtendedWorkFields_1.default, { fields: fields, defaultClassName: 'data-field' })),
                react_1.default.createElement(WorkItemPillSection_1.WorkItemPillSection, { work: work, showOverclaimStatus: !!showOverclaimStatus })),
            react_1.default.createElement("div", { className: 'right-data' }, secondaryFields ? (react_1.default.createElement(ExtendedWorkFields_1.default, { fields: secondaryFields, defaultClassName: 'secondary-work-data' })) : (react_1.default.createElement(ExtendedWorkWriterFields_1.default, { work: work }))),
            props.children),
        bottomFields && (react_1.default.createElement("div", { className: 'bottom' },
            react_1.default.createElement(ExtendedWorkFields_1.default, { fields: bottomFields, defaultClassName: 'tertiary-work-data' })))));
};
exports.default = (0, mobx_react_1.observer)(ExtendedWorkItem);
